import { Icon } from 'antd';
export const MyIcon = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1070825_188nuy8pqjz.js',
});
export const IMG_DEFAULT = require('../images/default.jpg');
export const HEAD_DEFAULT = require('../images/head.png');
export const noDataImg = require('../images/noneData.png');
export const noDataImg2 = require('../images/noneData2.png');
export const noDataImg3 = require('../images/noneData3.png');
export const api = '/service';
export const bgs = [
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg1_103359.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg2_103523.png',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg3_103538.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg4_103558.png',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg5_103611.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg6_103631.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg7_103642.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg8_103657.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg9_103710.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg10_103722.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg11_103738.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg12_103750.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg13_103803.jpg',
  'https://ctfive.oss-cn-hangzhou.aliyuncs.com/Course/2019/08/30/bg14_103842.jpg',
];
// export const cbURL = 'http://web.hwx.uat.chutoukj.com/'
//UAT
// export const cbURL = 'http://wx.test.chutoukj.com/'//测试
export const cbURL = 'http://wx.web.chutoukj.com/'; //线上

//单点登录地址 - uat

// export const ssoUrl = "http://gateway.uat.chutoukj.com/service";

//单点登录地址 - 正式
export const ssoUrl = 'https://gateway.chutoukj.com';



// WEBPACK FOOTER //
// ./src/common/baseConfig.js